import angular from 'angular';
import uiRouter from 'angular-ui-router';
import managerAsEmployeeCalendarMobileComponent from './managerAsEmployeeCalendarMobile.component';
import inceptionHeader from './inceptionHeader/inceptionHeader';
import {ROUTES} from 'common/domain/routes';
import {STATES} from 'common/domain/states';

let managerAsEmployeeCalendarMobileModule = angular.module('vacations-absences.managerAsEmployeeCalendarMobile', [
  uiRouter,
  inceptionHeader
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR_MOBILE, {
        url: ROUTES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR_MOBILE,
        component: 'managerAsEmployeeCalendarMobile'
      });
  })

  .component('managerAsEmployeeCalendarMobile', managerAsEmployeeCalendarMobileComponent)

  .name;

export default managerAsEmployeeCalendarMobileModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/managerAsEmployeeCalendarMobile/managerAsEmployeeCalendarMobile.js